import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Select buscável (Tom Select) — só para selects de alta cardinalidade (categoria,
// contraparte). Não crie opção nova a partir do texto digitado; é só busca.
export default class extends Controller {
  static values = { placeholder: { type: String, default: "Buscar..." } }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      allowEmptyOption: true,
      placeholder: this.placeholderValue,
      plugins: [],
      maxOptions: null,
      dropdownParent: "body"
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
